<script setup>
import VueMultiselect from "vue-multiselect";
import useAutocompleter from "@/composables/useAutocompleter";
import marketsService from "@/services/markets.service";
import {computed} from "vue";

const props = defineProps({
    value: Array,
    multiple: Boolean,
    defaultList: {
        type: Array,
        default: () => []
    }
});

const emit = defineEmits(['input']);

const {model, list, query, updateList} = useAutocompleter(props, getList, emit);

const actualList = computed(() => {
    if (query.value.length) {
        return list.value;
    } else {
        return props.defaultList;
    }
})

function getList(query) {
    return marketsService.searchPartnershipCorporates(query);
}
</script>

<template>
    <VueMultiselect
        v-model="model"
        placeholder="Select Enterprise"
        :options="actualList"
        :multiple="multiple"
        select-label=""
        deselect-label=""
        label="name"
        track-by="name"
        class="multiselect-mid pl-2"
        @search-change="updateList"
    />
</template>

<style scoped>

</style>
